export const NOTIFICATION_ALERT = 'notifications/NOTIFICATION_ALERT';
export const NOTIFICATION_SUCCESS = 'notifications/NOTIFICATION_SUCCESS';
export const NOTIFICATION_FAILURE = 'notifications/NOTIFICATION_FAILURE';
export const MESSAGE_DISPLAY_TIME = 30000;
export const TRANSITION_TIME = 2000;
